import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import AlertIcon from 'dibs-vg/dist/react/alert-bell';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import { trackEvent } from 'dibs-tracking';
import get from 'lodash.get';

const CART_KEY = 'cart';

export class PdpSharedBlurbUrgencyComponent extends React.Component {
    componentDidMount() {
        const urgencyKey = get(this.props, 'item.urgency.pdpBlurbDisplayInfo.key') || '';
        if (urgencyKey) {
            trackEvent({
                category: 'product',
                action: 'urgency metric displayed',
                label: urgencyKey === CART_KEY ? 'add to cart' : 'make offer',
            });
        }
    }
    render() {
        const urgencyTitle = get(this.props, 'item.urgency.pdpBlurbDisplayInfo.displayTitle');
        const urgencySubtitle = get(this.props, 'item.urgency.pdpBlurbDisplayInfo.displaySubtitle');
        if (!urgencyTitle || !urgencySubtitle) {
            return null;
        }

        return (
            <PdpSharedBlurb
                IconComponent={AlertIcon}
                iconClass={styles.alertIcon}
                dataTn="pdp-blurb-urgency"
            >
                <span className={styles.title}>{urgencyTitle} </span>
                {urgencySubtitle}
            </PdpSharedBlurb>
        );
    }
}

PdpSharedBlurbUrgencyComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const PdpSharedBlurbUrgency = createFragmentContainer(PdpSharedBlurbUrgencyComponent, {
    item: graphql`
        fragment PdpSharedBlurbUrgency_item on Item {
            urgency(userId: $userId) {
                pdpBlurbDisplayInfo {
                    key
                    displayTitle
                    displaySubtitle
                }
            }
        }
    `,
});
